// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"09181771","455":"f6031099","977":"2b077f88"}[chunkId] + ".chunk.js";
};